import React from 'react';
import ADFooter from './AD/ADFooter';
import MottoV2Footer from './MottoV2/MottoV2Footer';
import MottoFooter from './Motto/MottoFooter';
import WNResearchFooter from './WellNowResearch/WNResearchFooter';

var Footer = function Footer(_ref) {
  var contentfulData = _ref.contentfulData;
  var brandName = contentfulData.branding;

  switch (brandName) {
    case 'aspendental':
      return React.createElement(ADFooter, {
        contentfulData: contentfulData
      });

    case 'mottoV2':
      return React.createElement(MottoV2Footer, {
        contentfulData: contentfulData
      });

    case 'motto':
      return React.createElement(MottoFooter, {
        contentfulData: contentfulData
      });

    case 'wellnow':
      return React.createElement(WNResearchFooter, {
        contentfulData: contentfulData
      });

    default:
      throw new Error('Footer is required, Please create a brand specified footer component.');
  }
};

export default Footer;